import { render } from "./LoadingPage.vue?vue&type=template&id=afd97a2c&scoped=true"
const script = {}

import "./LoadingPage.vue?vue&type=style&index=0&id=afd97a2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd97a2c"]])

export default __exports__